import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';
@Component({
    selector: 'installation-bobst-attendees',
    templateUrl: './bobst-attendees.component.html',
    standalone: false
})
export class InstallationBobstAttendeesPluginComponent {
  public attendees: any[] = [];
  public config: any;
  public editRoute = ['installation', 'bobstattendees', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.attendees = this.config.Attendees;
  }
}
PluginComponent.plugins['installationbobstattendees'] = InstallationBobstAttendeesPluginComponent;
